/**
 * Created by fers on 23.05.16.
 */

/**
 * This panel is used when we are missing any screen/
 */

import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';

import {MiniPanel} from './EmbededPanel.react';
import {isPanelInjected} from '../loadingLine/renderLoadingPanel.react';
import urlMapping from '../app/URLMapping';
import {FormattedMessage, IntlShape} from 'react-intl';
import config from '../../common/config';
import EventTracker from '../app/EventTracker';
import LoadingButton from '../fw/LoadingButton.react';
import {openDialog, isOutlookPanel} from '../../outlook/dialog';
import {lastPanelController, sendMessage} from './EmbededPanelController';
import IotClient from '../../common/util/IotClient';
import {allowedMiniPanel} from '../embedPanel';
import { User } from '../../common/types/types';

interface NoScreenPanelProps {
 user: User;
}

class NoScreenPanel extends React.Component<NoScreenPanelProps> {

    static contextTypes = {
        embededPanelController: PropTypes.object,
        router: PropTypes.object,
    };

    static propTypes = {
        user: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);

        EventTracker.initEventTracker(props.user);

        IotClient.setConfig(this.props.user.iotTopic);
    }

    config = () => {
        lastPanelController().cancelMinimizePanel();

        let path = urlMapping.getUrl("panel", "create-screen-step-2", this.context.embededPanelController.getURLObject());

        if (isOutlookPanel()) {
            openDialog(path);
        }
        else if (isPanelInjected()) {
            sendMessage({msg: 'dativeryScreenSettings', url: path});
        }
        else {
            this.context.router.push(path);
        }
    };

    render() {
        return (
            <MiniPanel config={this.config} typeForTest="no-screen">
                {allowedMiniPanel() ? null :
                    (<div className="bordered-content">
                        <div className="embedLoading">
                            <div style={{paddingTop: '2em'}}>
                                <strong><FormattedMessage defaultMessage="No Screen Defined" id="screenSettings.noScreen.title"/></strong><br/>
                                <FormattedMessage defaultMessage="To start using {product} you have to create a screen." id="screenSettings.noScreen.description.1" values={{product: config.PRODUCT_NAME}} />
                                {" "}<LoadingButton className="btn btn-primary" onClick={this.config}><span className="fa fa-cog" />{" "}<FormattedMessage defaultMessage="Create screen" id="screenSettings.noScreen.createScreen"/></LoadingButton>
                            </div>
                        </div>
                    </div>)
                }
            </MiniPanel>
        );
    }
}

export default Relay.createContainer(NoScreenPanel, {
    fragments: {
        user: () => {
            return Relay.QL`
                fragment on User {
                    id,
                    realId,
                    ${EventTracker.getFragment()},
                    iotTopic,
                }
            `;
        }
    }
});
